export default "__VITE_ASSET__Db3GfoS___"